// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/turbulence-intensity-and-reporting.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/turbulence-intensity-and-reporting/turbulence-intensity-and-reporting.js';

mount([g0]);
